import type { QueryClient } from "@tanstack/react-query";

import { ptKeys } from "./keys";

export const invalidatePtSlots = (
  queryClient: QueryClient,
  clubId: number,
) => {
  queryClient.invalidateQueries({
    queryKey: [...ptKeys.club(clubId), "slots"],
  });
  queryClient.invalidateQueries({
    queryKey: [...ptKeys.club(clubId), "trainer-slots"],
  });
};

export const invalidatePtMember = (
  queryClient: QueryClient,
  clubId: number,
) => {
  queryClient.invalidateQueries({ queryKey: ptKeys.mine(clubId) });
  invalidatePtSlots(queryClient, clubId);
  queryClient.invalidateQueries({ queryKey: ptKeys.club(clubId) });
};

export const invalidatePtTrainer = (
  queryClient: QueryClient,
  clubId: number,
) => {
  queryClient.invalidateQueries({ queryKey: ptKeys.requests(clubId) });
  queryClient.invalidateQueries({ queryKey: ptKeys.schedule(clubId) });
  queryClient.invalidateQueries({ queryKey: ptKeys.availability(clubId) });
  queryClient.invalidateQueries({
    queryKey: [...ptKeys.availability(clubId), "exceptions"],
  });
  invalidatePtSlots(queryClient, clubId);
  queryClient.invalidateQueries({ queryKey: ptKeys.club(clubId) });
};

export const invalidatePtTrainerAndMember = (
  queryClient: QueryClient,
  clubId: number,
) => {
  invalidatePtTrainer(queryClient, clubId);
  invalidatePtMember(queryClient, clubId);
};
